import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { GradeService } from 'src/app/school-management/_services/grades.service';
import { GlobalService } from 'src/app/_services/global.service';
import { environment } from 'src/environments/environment';
import { DashboardService } from '../_services/dashboard.service';


declare var $: any;

@Component({
  selector: 'app-students-tracking',
  templateUrl: './students-tracking.component.html',
  styleUrls: ['./students-tracking.component.scss']
})
export class StudentsTrackingComponent implements OnInit {
  loading = true;
  printSub;
  activeTab = 'students';
  dataArray = [];
  baseuUlr = environment.img_url;
  grades: any = [];
  selectedGradeindex = 0;
  selectedClassName = '';
  selectedClassId = '';
  noClassFlag=false;
  currLang;
  constructor(
    private router: Router,
    private globalService: GlobalService,
    private translate: TranslateService,
    private dashboardService: DashboardService,
    private dataService: DataService,
    private gradesService:GradeService) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.printSub = new Subscription();
  }

  ngOnDestroy(): void {
    this.printSub.unsubscribe();
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    // this.loading = false;
    this.dataService.getAllGrades().subscribe(res => {
      this.grades = res;
      this.selectedClassId = this.grades[this.selectedGradeindex]?.school_classes[0]?.id;
      this.selectedClassName = this.grades[this.selectedGradeindex]?.school_classes[0]?.name;
      this.setStudentsViewValues();
    })

    // let p = this.dashboardService.getDownloadData().subscribe((res: any) => {
    //   if (res && this.router.url.split('/')[2] === 'dismissal-reports' && this.activeTab !== 'home-tab') {
    //     let workBook = XLSX.utils.book_new();
    //     workBook.SheetNames.push('test sheet');
    //     let valuesToBeExported = [];
    //     let controlType = this.getControlType();        
    //     if (controlType === 'students-log') {
    //       valuesToBeExported = this.dataArray.map(data => {
    //         return {
    //           'name': data['name'],
    //           'national_id': data['national_id'],
    //           'requested_by': data['requested_by'],
    //           'delivered_by': data['delivered_by']
    //         }
    //       })
    //     }
    //     if (controlType === 'average') {
    //       valuesToBeExported = this.dataArray.map(data => {
    //         return {
    //           'national_id': data['national_id'],
    //           'name': data['name'],
    //           'avg_till_pickup': data['avg_till_pickup'],
    //           'avg_till_received': data['avg_till_received'],
    //           'avg_full_time': data['avg_full_time'],
    //         }
    //       })

    //     }
    //     let ws_Data = valuesToBeExported;
    //     let ws = XLSX.utils.json_to_sheet(ws_Data);
    //     workBook.Sheets['test sheet'] = ws;
    //     let workBookOut = XLSX.writeFile(workBook, 'book.xlsx');

    //     function s2ab(s) {
    //       let buf = new ArrayBuffer(s.length);
    //       let view = new Uint8Array(buf);
    //       for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
    //       return buf;
    //     }
    //     $("#button-a").click(function () {
    //       FILESAVER.saveAs(new Blob([s2ab(workBookOut)], { type: "application/octet-stream" }), 'test.xlsx');
    //     });


    //   }
    // })
    // this.printSub.add(p);
  }

  changeTab(tabName = null) {
    if (tabName != this.activeTab) {
      this.activeTab = tabName ? tabName : this.activeTab;
      switch (this.activeTab) {
        case 'students':
          this.selectedClassId = this.grades[this.selectedGradeindex]?.school_classes[0]?.id;
          this.setStudentsViewValues();
          break;
        case 'staff':
          this.setStaffViewValues();
          break;
        case 'grades':
          this.setGradesViewValues();
          break;
      }
    }
  }

  changeTabClass(tabName = null) {
    if (tabName != this.activeTab) {
      this.activeTab = tabName ? tabName : this.activeTab;
      switch (this.activeTab) {
        case 'students':
          // this.selectedClassId = this.grades[this.selectedGradeindex]?.school_classes[0]?.id;
          this.setStudentsViewValues();
          break;
        case 'staff':
          this.setStaffViewValues();
          break;
        case 'grades':
          this.setGradesViewValues();
          break;
      }
    }
  }
  setStudentsViewValues() {
    this.translate.get('init').subscribe(res => {
      this.studentValues();
    });
    this.translate.onLangChange.subscribe(res => {
      this.studentValues();
    })
    this.getStudentsReport();
  }
  studentValues() {
    this.dataArray = [
      {
        header: this.translate.instant('student-dismissal-track.not-requested'),
        dataSet: []
      },
      {
        header: this.translate.instant('student-dismissal-track.getting-ready'),
        dataSet: []
      }, {
        header: this.translate.instant('student-dismissal-track.student-staff'),
        dataSet: []
      }, {
        header: this.translate.instant('student-dismissal-track.delivered'),
        dataSet: []
      }
    ];
  }
  setStaffViewValues() {
    this.translate.get('init').subscribe(res => {
      this.staffValues();
    });
    this.translate.onLangChange.subscribe(res => {
      this.staffValues();
    })
    this.getStaffReport();
  }
  staffValues() {
    this.dataArray = [
      {
        header: this.translate.instant('student-dismissal-track.teachers'),
        dataSet: []
      },
      {
        header: this.translate.instant('student-dismissal-track.supervisors'),
        dataSet: []
      }, {
        header: this.translate.instant('student-dismissal-track.guards'),
        dataSet: []
      }, {
        header: this.translate.instant('student-dismissal-track.buses'),
        dataSet: []
      }
    ];
  }
  setGradesViewValues() {
    this.dataArray = [];
    this.getGradesReport();
  }
  getStudentsReport() {
    this.loading = true;
    this.noClassFlag=false;
    if(this.selectedClassId==undefined){ 
      this.noClassFlag=true;
      this.loading = false;
    }
    else{
      this.dashboardService.getDismissalTrackingStudents(this.grades[this.selectedGradeindex].id, this.selectedClassId).subscribe((res: any) => {
        this.dataArray[0].dataSet = res.not_requested;
        this.dataArray[1].dataSet = res.get_ready;
        this.dataArray[2].dataSet = res.with_staff;
        this.dataArray[3].dataSet = res.delivered;
  
        this.loading = false;
      })
    }
  }
  getStaffReport() {
    this.loading = true;
    this.dashboardService.getDismisssalTrackingStaff().subscribe((res: any) => {
      this.dataArray[0].dataSet = res.teachers;
      this.dataArray[1].dataSet = res.supervisors;
      this.dataArray[2].dataSet = res.guards;
      this.dataArray[3].dataSet = res.drivers;

      this.loading = false;
    })

  }
  getGradesReport() {
    this.loading = true;
    this.dashboardService.getDismisssalTrackingGrades().subscribe((res: any) => {
      this.dataArray = res;
      this.loading = false;
    })

  }

  extend(dataElement, flag) {
    dataElement.extendFlag = flag;
  }
  back() {
    this.router.navigateByUrl('/reports/dashboard');
  }
}
